import * as moment from 'moment';

import { IDataSorter } from 'app/slick-grid/interfaces/data-sorter';

export class DataSorter<T extends Slick.SlickData> implements IDataSorter<T> {
    constructor() {
        this.customComparers = {};
    }

    readonly customComparers: { [fieldId: string]: (a: T, b: T, dataSorter: IDataSorter<T>) => number; };

    readonly multiColumnSorter = (a: T, b: T, sortCols: Slick.SortColumn<T>[]): number => {
        for (const col of sortCols) {
            const result = this.sorter(a, b, col.sortCol, col.sortAsc);
            if (result !== 0)
                return result;
            //const result = this.compare(a, b, col.sortCol.field);
            //if (result !== 0)
            //    return !col.sortAsc ? result * -1 : result;
        }

        return 0;
    }

    readonly sorter = (a: T, b: T, col: Slick.Column<T>, sortAsc: boolean): number => {
        const result = this.compare(a, b, col.field);
        return sortAsc ? result : (result * -1);
    }

    readonly sort = (args: Slick.OnSortEventArgs<T>): void => {
        const data = args.grid.getData();
        if (!data)
            return;

        const sort: (a: T, b: T)=> number = args.multiColumnSort
            ? (a, b)=> this.multiColumnSorter(a, b, args.sortCols)
            //{
            //    for (const col of args.sortCols) {
            //        const result = this.compare(a, b, col.sortCol.field);
            //        if (result !== 0)
            //            return !col.sortAsc ? result * -1 : result;
            //    }

            //    return 0;
            //}
            : (a, b) => this.sorter(a, b, args.sortCol, args.sortAsc)
            //{
            //    const result = this.compare(a, b, args.sortCol.field);
            //    return !args.sortAsc ? result * -1 : result;
            //}
            ;

        if (data instanceof Slick.Data.DataView) {
            (data as Slick.Data.DataView<T>).sort(sort, true);
            return;
        }

        data.sort(sort);
        args.grid.invalidate();
        args.grid.render();
    }

    readonly compare = (a: T, b: T, field?: string): number => {
        if (field != null) {
            const customCompare = this.customComparers[field];
            if (customCompare)
                return customCompare(a, b, this);
        }

        return this.defaultCompare(a, b, field);
    }

    private defaultCompare=(a: T, b: T, field?: string): number => {
        let valA = field ? a[field] : a;
        let valB = field ? b[field] : b;
        if (moment.isDuration(valA) || moment.isDuration(valB)) {
            valA = valA == null ? null : valA.asMilliseconds();
            valB = valB == null ? null : valB.asMilliseconds();
        }
        else if (moment.isMoment(valA) || moment.isMoment(valB)) {
            valA = valA == null ? null : valA.valueOf();
            valB = valB == null ? null : valB.valueOf();
        }
            //try {
            //    return valA == null && valB == null ? 0 : valA == null && valB != null ? -1 : valB == null && valA != null ? 1 : valA.diff(valB);
            //} catch (e) {
            //    return 0;
            //}
        //else
            return valA === valB || (valA == null && valB == null) ? 0 : (valA > valB || (valA != null && valB == null)) ? 1 : -1;
    }

    //private sortByMultipleColumns = (a: T, b: T, columns: Slick.SortColumn<T>[]): number => {
    //    for (const col of columns) {
    //        const result = this.compare(a, b, col.sortCol.field);
    //        if (result !== 0)
    //            return !col.sortAsc ? result * -1 : result;
    //    }

    //    return 0;
    //}

    //private sortByColumn = (a: T, b: T, column: Slick.SortColumn<T>): number => {
    //    const result = this.compare(a, b, column.sortCol.field);
    //    return !args.data.sortAsc ? result * -1 : result;
    //}
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/data-sorter.ts